<template lang="html">

  <!-- top bar -->
  <v-app-bar
    app
    dark
    dense
    flat
  >
    <!--  tag="span" span="cursor: pointer" -->
    <!-- add logo -->
    <v-btn fab color="white" text router to= "/">
      <v-avatar size="96"><v-img src="@/assets/logo.svg"></v-img></v-avatar>
    </v-btn>
    <h3>Welcome to Whist!</h3>
    <v-spacer></v-spacer>

    <v-btn dark depressed router to="/findPeople"><v-icon>mdi-account-search</v-icon></v-btn>
    <v-btn dark depressed router to="/invites"><v-icon>mdi-call-split</v-icon></v-btn>
    <v-btn dark depressed router to="/create/group-chat"> <v-icon>mdi-email</v-icon></v-btn>

    <!-- sign out -->
    <!-- <v-toolbar-items><v-btn v-if="userIsAuthenticated" text color="white" @click.stop="onSignOut()"><v-icon>mdi-exit-to-app</v-icon>Sign Out</v-btn></v-toolbar-items> -->

  </v-app-bar>

</template>

<script>

export default {
}
</script>

<style lang="css" scoped>
</style>
